var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIconEth2(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 11,
    height: 16,
    viewBox: "0 0 11 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_12660_8200)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M5.58332 0L5.47607 0.364508V10.9417L5.58332 11.0487L10.4931 8.14657L5.58332 0Z",
    fill: "#343434"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.5834 0L0.673584 8.14657L5.5834 11.0488V5.91494V0Z",
    fill: "#8C8C8C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.58338 11.9788L5.52295 12.0525V15.8203L5.58338 15.9969L10.4961 9.07812L5.58338 11.9788Z",
    fill: "#3C3C3B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.5834 15.9969V11.9788L0.673584 9.07812L5.5834 15.9969Z",
    fill: "#8C8C8C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.5835 11.0478L10.4932 8.1457L5.5835 5.91406V11.0478Z",
    fill: "#141414"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0.673584 8.1457L5.58332 11.0478V5.91406L0.673584 8.1457Z",
    fill: "#393939"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_12660_8200"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 9.83,
    height: 16,
    fill: "white",
    transform: "translate(0.669922)"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconEth2);
export default __webpack_public_path__ + "static/media/icon-eth2.6e8b8ed5.svg";
export { ForwardRef as ReactComponent };